export default __webpack_public_path__ + "static/benefits-6915cdbe55de7f624946f425e656ddab9f4942acb3f3ce1b3f828d73a2c241b1.png";